<template>
  <v-container fluid>
    <v-row>
      <v-col :order="opposite ? 2 : 1" class="pa-lg-12">
        <v-row>
          <v-col cols="auto">
            <v-avatar v-if="value.icon" rounded="0" size="170">
              <v-img :src="iconSrc(value.icon)" alt="Package overview icon" />
            </v-avatar>
          </v-col>

          <v-col lg="12">
            <TitleParagraphBlock :value="value" />
          </v-col>
        </v-row>
      </v-col>

      <v-col :order="opposite ? 1 : 2" class="d-none d-lg-flex ma-n4" cols="4">
        <v-img
          :aspect-ratio="aspectRatio"
          :sizes="imgResp.sizes"
          :src="imgResp.src"
          :srcset="imgResp.srcset"
          alt="Photo for this package overview"
          cover
          height="100%"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { toRef } from 'vue'
import { createImgSrc, useImgResponsive } from '#root/lib/img'

const props = defineProps({
  opposite: {
    default: false,
    type: Boolean
  },
  value: {
    required: true,
    type: Object
  }
})

const aspectRatio = 2 / 1
const iconSrc = createImgSrc()
const imgResp = useImgResponsive(
  toRef(() => ({
    aspectRatio,
    image: props.value.image,
    sizes: {
      lg: '1600px'
    }
  }))
)
</script>
